/**
 * URL immagini premi/catalogo — allineato a EventDetail / Bazar:
 * - REACT_APP_PUBLIC_MEDIA_URL per gli upload Strapi
 * - path relativi /uploads → proxy CRA in dev
 * - URL localhost:1337 riscritti in path relativi per il proxy
 */

const getPublicMediaBase = () => {
  const raw =
    process.env.REACT_APP_PUBLIC_MEDIA_URL ||
    process.env.REACT_APP_STRAPI_URL ||
    process.env.REACT_APP_STRAPI_API_URL ||
    '';
  return raw.replace(/\/api\/?$/i, '').replace(/\/+$/, '');
};

const pickMediaPath = (media) => {
  if (!media) return null;
  if (typeof media === 'string') return media;
  if (media.data?.attributes) {
    return pickMediaPath(media.data.attributes);
  }
  const formats = media.formats || {};
  return (
    media.url ||
    formats.large?.url ||
    formats.medium?.url ||
    formats.small?.url ||
    formats.thumbnail?.url ||
    null
  );
};

/** Path relativo /uploads/… (ordini legacy o Strapi con URL assoluto). */
export const normalizeUploadUrl = (url) => {
  if (!url || typeof url !== 'string') return null;
  const trimmed = url.trim();
  if (!trimmed) return null;

  if (/^https?:\/\//i.test(trimmed)) {
    try {
      const parsed = new URL(trimmed);
      if (parsed.pathname.startsWith('/uploads/')) {
        return parsed.pathname;
      }
      return trimmed;
    } catch {
      return trimmed;
    }
  }

  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
};

export const toRewardMediaUrl = (urlOrMedia) => {
  const rawPath = pickMediaPath(urlOrMedia);
  const imageUrl = normalizeUploadUrl(rawPath);
  if (!imageUrl) return null;

  if (/^https?:\/\//i.test(imageUrl)) {
    return imageUrl;
  }

  const baseUrl = getPublicMediaBase();
  if (baseUrl) {
    return `${baseUrl}${imageUrl.startsWith('/') ? imageUrl : `/${imageUrl}`}`;
  }

  return imageUrl.startsWith('/') ? imageUrl : `/${imageUrl}`;
};

export const getRewardImageUrl = (image) => toRewardMediaUrl(image);
